import React from "react";

import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";


import {
    Navbar,
    Footer,
    Home,
    Login,
    SignUp,
    Profile,
    Activities,
    AddActivity,
    EditActivity,
    Routines,
    AddRoutine
} from "./components";

function App() {
    const [token, setToken] = useState("");
    const [username, setUsername] = useState("");

    useEffect(() => {
        let savedToken = localStorage.getItem("token");
        if (savedToken) {
            setToken(savedToken);
            fetch("https://fitnesstrac-kr.herokuapp.com/api/users/me", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${savedToken}`,
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    setUsername(result.username);
                    // setUsername(result.username);
                    console.log(result)
                })
                .catch(console.error);
        }
    }, []);


    return (
        <>
            <Navbar token={token} setToken={setToken} />

            <Routes>
                <Route path="Home" element={<Home />}></Route>
                <Route path="Profile/" element={<Profile />}></Route>
                <Route path='Activities' element={<Activities />}></Route>
                <Route path="Login" element={<Login setToken={setToken} />}></Route>
                <Route path="SignUp" element={<SignUp setToken={setToken} />}></Route>
                <Route path="Activities/Add" element={<AddActivity />}></Route>
                <Route path="Activities/Edit" element={<EditActivity />}></Route>
                <Route path="Routines" element={<Routines />}></Route>
                <Route path="Routines/Add" element={<AddRoutine />}></Route>
            </Routes>
            <Footer />



        </>
    );
}


const root = ReactDOM.createRoot(document.getElementById("app"));

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

